// ============================================================
// ARTWORK SALE PRICING — 20% discount display on variant switch
// Applies only to products with data-artwork-sale="true" on their
// price container (i.e. products in the 'artwork' collection).
//
// Toggle on/off via: Shopify Admin → Theme → Theme Settings → Artwork Sale
// ============================================================

if (window.theme?.artworkSaleActive) {
  function artworkFormatMoney(cents) {
    const fmt = window.theme?.money_product_price_format || window.theme?.money_format || '£{{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
  }

  function applyArtworkDiscount(priceContainer, variant) {
    if (!priceContainer || priceContainer.dataset.artworkSale !== 'true') return;
    if (!variant) return;

    const price = variant.price;
    const discounted = Math.round(price * 4 / 5);

    priceContainer.innerHTML = `
      <span class="price__number price__number--sale">
        <span class="money">${artworkFormatMoney(discounted)}</span>
      </span>
      <s class="price__compare" style="color:#999;">
        <span class="money">${artworkFormatMoney(price)}</span>
      </s>
    `;
  }

  customElements.whenDefined('variant-selects').then(() => {
    const VariantSelects = customElements.get('variant-selects');
    const _original = VariantSelects.prototype.renderProductInfo;

    VariantSelects.prototype.renderProductInfo = function () {
      _original.call(this);
      const priceContainer = document.getElementById(`price-${this.uniqueId}`);
      applyArtworkDiscount(priceContainer, this.currentVariant);
    };
  });
}
